import { render, staticRenderFns } from "./PageInfoPage.vue?vue&type=template&id=29c1a46c&"
import script from "./PageInfoPage.vue?vue&type=script&lang=js&"
export * from "./PageInfoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29c1a46c')) {
      api.createRecord('29c1a46c', component.options)
    } else {
      api.reload('29c1a46c', component.options)
    }
    module.hot.accept("./PageInfoPage.vue?vue&type=template&id=29c1a46c&", function () {
      api.rerender('29c1a46c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/infoPage/PageInfoPage.vue"
export default component.exports